import router from "../router";
import store from "../store/index.js";
import Global from "../tools/global"; // 引入global.js
// import { Message } from "element-ui";
import {
  message
} from '@/tools/resetMessage';
import Vue from "vue";
// 判断是否是分享页面，带有播放码
const shareRouterPaths = [
  "/home/openclassSharePage",
  "/home/resourceSharePage",
  "/home/albumSharePage",
  "/home/liveSharePage",
];
//判断是否登录的路由地址
var isLoginPage = location.href.indexOf("/login?");

//教师培训模块需要登陆
var token = localStorage.getItem("token");

// if (token == "--" && in_array(Global.decisionPlatform, Global.loginModule)) {
//   Message.error("请先登录");
//   setTimeout(() => {
//     router.push("/user-login");
//     return;
//   }, 2000);
// }

// 页面刷新初始化数据
if (is_empty(store.getters.isCheckToken) && isLoginPage === -1) {
  //是否设置路由session
  var routerData = [];
  routerData = Vue.prototype.checkRouter();
  //动态添加路由
  router.addRoutes(routerData);
  store.commit(
    "SET_USERINFO",
    !is_empty(sessionStorage.getItem("user_info_str")) ?
    JSON.parse(sessionStorage.getItem("user_info_str")) : {}
  );
  //设置全局用户id
  Global.user_id = !is_empty(sessionStorage.getItem("user_info_str")) ?
    JSON.parse(sessionStorage.getItem("user_info_str")).id :
    0;
  Global.user_name = !is_empty(sessionStorage.getItem("user_info_str")) ?
    JSON.parse(sessionStorage.getItem("user_info_str")).name :
    "";
}

const whiteList = ['/', '/user-login', '/login', '/register', '/cdkey"'];

//路由钩子
router.beforeEach((to, from, next) => {
  if (to.name === 'homeIndex') {
    sessionStorage.setItem('activeIndex', 0)
    store.commit('SET_ACTIVEINDEX', 0)
  }

  !localStorage.getItem("access_token", ) && Vue.prototype.get_access_token()
  // 判断是否还有分享参数
  const videoSignParam =
    shareRouterPaths.includes(to.path) && to.query.hasOwnProperty("video_sign") ?
    to.query.video_sign :
    "";
  sessionStorage.setItem("video_sign", videoSignParam);

  const resourceSignParam =
    shareRouterPaths.includes(to.path) &&
    to.query.hasOwnProperty("resource_sign") ?
    to.query.resource_sign :
    "";
  sessionStorage.setItem("resource_sign", resourceSignParam);

  const albumSignParam =
    shareRouterPaths.includes(to.path) && to.query.hasOwnProperty("album_sign") ?
    to.query.album_sign :
    "";
  sessionStorage.setItem("album_sign", albumSignParam);

  const liveSignParam =
    shareRouterPaths.includes(to.path) && to.query.hasOwnProperty("live_sign") ?
    to.query.live_sign :
    "";
  sessionStorage.setItem("live_sign", liveSignParam);

  if (to.name != "login") {
    if (store.getters.isCheckToken === null) {
      store.commit("UPDATE_ISCHECKTOKEN", true);
    }
  }


  if (localStorage.getItem('token')) {
    // console.log('----to.path',localStorage.getItem('userType') == 2 )
    // console.log('----to.path', !to.path.includes('customer-home'))
    // sessionStorage.getItem("userType") === 1
    if (localStorage.getItem('userType') == 2 && !(to.path.includes('customer-home'))) {
      next({
        path: '/customer-home'
      })
    } else {
      if (whiteList.includes(to.path)) {
        next({
          path: '/homeindex'
        });
      } else {
        next();
      }
    }
  } else {
    if (whiteList.includes(to.path)) {
      next();
    } else if (to.path === '/cdkey') {
      next();
    } else {
      next({
        path: '/user-login'
      });
      message.error("请先登录");
    }

  }

});
router.afterEach((transition) => {});